import { render, staticRenderFns } from "./DashboardEvents.vue?vue&type=template&id=175f1f5e"
import script from "./DashboardEvents.vue?vue&type=script&lang=js"
export * from "./DashboardEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports